import { Shimmer } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useThemeData } from '@msrceng/theme';

/**
 * UI for rendering the assigning CNA field on the CVE details page's title card.
 */
export const AssigningCna = ({
  assigningCna,
  loading,
}: {
  assigningCna?: string;
  loading?: boolean;
}) => {
  const { theme } = useThemeData();
  const [t] = useTranslation(['translation', 'vulnerability']);
  // Empty CNA value is used to indicate that the CVE was issued by Microsoft
  const isMicrosoft =
    !assigningCna || assigningCna.length < 2 || assigningCna === 'Microsoft';
  const assigningCnaText = isMicrosoft
    ? t('Microsoft', 'Microsoft')
    : assigningCna;
  const parentLabel = t('Assigning CNA', {
    defaultValue: 'Assigning CNA',
    nsSeparator: '::',
  });

  return (
    <dl
      style={{
        ...(isMicrosoft && {
          borderLeft: `4px solid ${theme.palette.themePrimary}`,
          paddingLeft: '0.5em',
        }),
      }}
    >
      <dt>{parentLabel}</dt>
      <dd>
        <Shimmer styles={{ root: { minWidth: '8em' } }} isDataLoaded={!loading}>
          {assigningCnaText}
        </Shimmer>
      </dd>
    </dl>
  );
};
